import {Typography} from '@sollapay/ui/components';

import {useDealTypeTranslation} from '@/lib/i18n';
import {getTranslatedErrorMessages} from '@/utils';

import type {TrustPurpose} from '@sollapay/enums';

interface InlineErrorProps {
  error: unknown;
  trustPurpose?: TrustPurpose | null;
}

export function InlineError({error, trustPurpose}: InlineErrorProps) {
  const {t} = useDealTypeTranslation('common', trustPurpose ?? null);
  const messages = getTranslatedErrorMessages(error, t);

  return (
    <Typography as="p" size="sm" className="text-destructive">
      {messages.join('. ')}
    </Typography>
  );
}
